import { render } from "./ModalUpdatePassword.vue?vue&type=template&id=fc77f45e&scoped=true"
import script from "./ModalUpdatePassword.vue?vue&type=script&lang=js"
export * from "./ModalUpdatePassword.vue?vue&type=script&lang=js"

import "./ModalUpdatePassword.vue?vue&type=style&index=0&id=fc77f45e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc77f45e"]])

export default __exports__